export default __webpack_public_path__ + "static/media/bunnyhead-main.527a65f8.svg";